import { session } from './session'

export function updateViewedProducts(sku: string) {
  const prev = session.viewedProducts.get(',') ?? []
  const skus = new Set(prev)

  if (skus.has(sku)) skus.delete(sku)
  skus.add(sku)

  const next = [...skus].reverse().join(',')
  session.viewedProducts.set(next)
}
